import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";

initSentry();


const isOAuthProxyPath = window.location.pathname.startsWith('/~oauth');

if (isOAuthProxyPath) {
  navigator.serviceWorker?.getRegistrations()
    .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
    .finally(() => {
      const hasRetried = sessionStorage.getItem('oauth-callback-retried') === 'true';

      if (hasRetried) {
        window.location.replace('/auth?oauth_error=callback');
        return;
      }

      sessionStorage.setItem('oauth-callback-retried', 'true');
      window.location.reload();
    });
} else if (!isOAuthProxyPath) {
  sessionStorage.removeItem('oauth-callback-retried');
}

/**
 * Checks if the Service Worker should be registered in the current environment.
 * Prevents registration in dev mode, iframes, and internal Lovable environments.
 */
function shouldRegisterServiceWorker(): boolean {
  // 1. Must be in production build
  if (!import.meta.env.PROD) return false;

  // 2. Browser must support Service Workers
  if (!('serviceWorker' in navigator)) return false;

  // 3. Must NOT be inside an iframe
  if (window.self !== window.top) return false;

  // 4. Must NOT have explicit override in URL
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('sw') === 'off') return false;

  // 5. Must NOT be an internal Lovable or preview environment
  const hostname = window.location.hostname;
  const isInternalEnvironment = 
    hostname.startsWith('id-preview--') ||
    hostname.startsWith('preview--') ||
    hostname.endsWith('.lovableproject.com') ||
    hostname.endsWith('.lovableproject-dev.com') ||
    hostname.endsWith('.beta.lovable.dev');

  if (isInternalEnvironment) return false;

  return true;
}

// Register unified service worker
if (!isOAuthProxyPath && shouldRegisterServiceWorker()) {
  window.addEventListener('load', () => {
    // The service worker filename after build is sw.js (configured in vite.config.ts)
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        if (import.meta.env.DEV) {
          console.log('Unified Service Worker registered:', registration.scope);
        }
      })
      .catch((error) => {
        // Only log errors in dev or if registration was expected but failed
        if (import.meta.env.DEV) {
          console.error('Service Worker registration failed:', error);
        }
      });
  });
}

if (!isOAuthProxyPath) {
  createRoot(document.getElementById("root")!).render(<App />);
}
